//Constante utilisée dans toute l'application en cas d'erreur
export const ERROR_MESSAGE_GENERIC = 'Une erreur est survenue : vous pouvez contacter le sddea';
export const ERROR_MESSAGE_NO_NETWORK = "Oups... Vous n'avez plus de connexion internet";
// ROLES
export const ROLE_ADMIN = 'ROLE_WEBSERVICE_USAGER_ADMIN';
export const ROLE_COMM = 'ROLE_WEBSERVICE_USAGER_COMM';

//Constante message d'erreur pour les mails
export const ERROR_MAIL = 'Veuillez saisir une adresse email valide';

// Mapping de champs dtos en en champs d'affichage
export const FIELDS = new Map([
    ['identifiant', 'Identifiant'],
    ['motDePasse', 'Mot de passe'],
    ['utilisateur.nomNaissance', 'Nom de naissance'],
    ['utilisateur.nomUsage', 'Nom'],
    ['utilisateur.prenom', 'Prénom'],
    ['utilisateur.type', 'Interlocuteur'],
    ['utilisateur.civilite', 'Civilité'],
    ['utilisateur.telPort', 'Téléphone'],
    ['utilisateur.mailPerso', 'Email'],
    ['utilisateur.dateNaissance', 'Date de naissance'],
    ['captcha', 'Captcha'],
    ['tel', 'Téléphone'],
    ['mail', 'Email'],
    ['nom', 'Nom'],
    ['prenom', 'Prénom'],
    ['bic', 'BIC'],
    ['iban', 'IBAN'],
    ['rib', 'RIB'],
]);

/**
 * Map that represents the labels for different request status.
 *
 * The keys of the map represent the request status codes,
 * while the values represent the corresponding labels for each status code.
 *
 * @type {Map<string, string>}
 */
export const REQUEST_STATUS_LABEL: Map<string, string> = new Map([
    ['0', 'Terminée'],
    ['1', 'En cours'],
    ['2', 'Abandonné'],
]);

/**
 * Represents a map to store the color associated with each request status code.
 *
 * @type {Map<string, string>}
 */
export const REQUEST_STATUS_COLOR: Map<string, string> = new Map([
    ['0', 'success'],
    ['1', 'info'],
    ['2', 'error'],
]);

// Statut HTTP
export const httpCodeBadRequest = 400;
export const httpUnauthorized = 401;
export const httpCodeNotFound = 404;
export const httpCodeNotAcceptable = 406;
export const httpCodeConflict = 409;
export const httpCodeInvalidInputs = 422;
export const httpCodeBrokenNetwork = 'ERR_NETWORK';

//Types api
export const YEARS = 'years';
export const MONTHS = 'months';
export const DAYS = 'days';
